
import { DatePicker, TextField } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { TownSelect } from "../../components/FormControls/TownSelect";
import UploadButton from "../../components/UploadButton";
import { DocumentType } from "../../models/Document";
import { OtherLegalEntityLocation } from "../../models/ProgramRequest";
import styles from "./ProgramRequestDetails.module.scss";

interface Props {
  otherLegalEntityLocation: OtherLegalEntityLocation;
}

export default function OtherLegalEntityPanel({ otherLegalEntityLocation }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <div key={otherLegalEntityLocation.id} /* className={styles.locationPanel} */>
        <Row className={styles.dataRow}>
          <Col md={3}>
            <DatePicker
              label={t("common.dateFrom")}
              value={otherLegalEntityLocation.dateFrom}
              plaintext
            />
          </Col>
          <Col md={3}>
            <DatePicker
              label={t("common.dateTo")}
              value={otherLegalEntityLocation.dateTo}
              plaintext
            />
          </Col>          
        </Row>
        <Row className={styles.dataRow}>
          <Col md={4} className={styles.hideUploadButton}>
            <UploadButton
              label={t("request.programExecutionRequest")}
              className={styles.uploadButtonInRowSection}
              value={otherLegalEntityLocation.programExecutionRequestDocument}
              disabled={true}
              documentType={DocumentType.OtherLegalEntityProgramExecutionRequest}
            />
          </Col>
          <Col md={4} className={styles.hideUploadButton}>
            <UploadButton
              label={t("request.ministryConsent")}
              className={styles.uploadButtonInRowSection}
              value={otherLegalEntityLocation.ministryConsentDocument}
              disabled={true}
              documentType={DocumentType.OtherLegalEntityMinistryConsent}
            />
          </Col>
          <Col md={4} className={styles.hideUploadButton}>
            <UploadButton
              label={t("otherLegalEntityLocation.personnelConditions")}
              className={styles.uploadButtonInRowSection}
              value={otherLegalEntityLocation.personnelConditionsDocument}
              disabled={true}
              documentType={DocumentType.OtherLegalEntityPersonnelConditions}
            />
          </Col>
        </Row>
        <Row className={styles.dataRow}>
          <Col md={12}>
            <TextField
              label={t("request.legalEntityName")}
              value={otherLegalEntityLocation.name}
              plaintext
              readonly
              className={styles.textFieldLabelWider}
            />
          </Col>
        </Row>
        <Row className={styles.dataRow}>
          <Col md={8}>
            <TownSelect
              initialValue={otherLegalEntityLocation.town?.id}
              readOnly
            />
          </Col>
          <Col md={4}>
            <TextField
              label={t("request.addressOtherLegalEntityLocation")}
              value={otherLegalEntityLocation.address}
              plaintext
              readonly
            />
          </Col>
        </Row>
      </div>
    </>
  )
}